import React from "react";
import { Box, DateRangePicker, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../common/PreviewAndEditor";

const DateRangePickerComponent = () => {
  return (
    <Stack direction={"column"} spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          Date Range Picker
        </Typography>
      </Box>
      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <PreviewAndEditor
          language="js"
          title={"Date Range"}
          value={"<DateRangePicker value={{from:new Date(), to:new Date()}} dualMonth={true} onChange={(value)=> {\n" +
              "              console.log(value)\n" +
              "          }} />"}
        >
          <DateRangePicker value={{from:new Date(), to:new Date()}} dualMonth={true} onChange={(value)=> {
              console.log(value)
          }} />
        </PreviewAndEditor>
      </Box>
    </Stack>
  );
};

export default DateRangePickerComponent;
